import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewEncapsulation, inject } from '@angular/core';

import { Client } from 'src/providers/client/client';

import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { WindowService } from 'src/shared/providers/window.service';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { Util } from 'src/shared/util/util';

@Component({
  selector: 'guest-messaging-onboarding',
  templateUrl: './guest-messaging-onboarding.component.html',
  styleUrls: ['./guest-messaging-onboarding.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class GuestMessagingOnboardingComponent implements OnInit {
  private client = inject(Client);
  private rightSidePanelService = inject(RightSidePanelService);
  private navCtrl = inject(CustomNavController);
  private cdr = inject(ChangeDetectorRef);
  private util = inject(Util);
  private storage = inject(TidyStorage);
  windowService = inject(WindowService);

  loaded = false;
  fromGettingStarted = false;
  private metadataKey: string;
  private readonly stepId = 'messaging';

  completeStep = async () => {
    try {
      await this.client.addMetadata({
        key: this.metadataKey,
        value: 'completed'
      });
      if (this.windowService.isDesktopRes) {
        this.rightSidePanelService.closeRightSidePanel();
      } else {
        this.navCtrl.navigateForward('getting-started');
      }
    } catch (err) {
      this.util.showError('Failed to complete step. Please try again.');
    }
  };

  async ngOnInit() {
    const params = await this.storage.retrieve('dialog-params');
    const addressId = params?.addressId;
    this.fromGettingStarted = !!params?.fromGettingStarted;
    this.metadataKey = `onboarding_step.${addressId}.${this.stepId}`;
    this.rightSidePanelService.setDialogPageTitle('Guest Messaging');
    this.loaded = true;
  }
}
